export const prettify = (s: string) => {
  if (s === 'Tmdx') return 'TMDX';
  if (/^[A-Z\d]+$/.test(s)) return s;
  return s.replace(/([A-Z])/g, ' $1').trim();
};
